import styled from 'styled-components';

import Container from '../Container.styled';

export const PoweredByWrapperStyled = styled(Container)`
  display: flex;
  justify-content: space-between;
`;

export const LogoStyled = styled.img`
  width: 120px;
  display: inline-block;
  margin-left: 10px;
`;

export const LogoWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  flex: 1;
`;

export const FooterStyled = styled.footer.attrs(() => ({
  className: 'fsTnLF',
}))`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 30px 60px 60px;

  ${({ theme }) => `
    font-size: ${theme.fontSize}px;
    background-color: ${theme.footerColour};  
    color: ${theme.whiteColour};

    ${theme.devices.touch} {
      padding: 20px;
    }

    p {
      color: ${theme.whiteColour};
    }

    .footer-row {
      h3 {
        font-size: calc(2px + ${theme.fontSize}px);
      }
  `}
`;
